var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("polygon",{"className":"st0","points":"0,0 20,10 0,20 ","key":1})]);
}

Triangle.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 20 20","style":{"enableBackground":"new 0 0 20 20"},"xmlSpace":"preserve"};

module.exports = Triangle;

Triangle.default = Triangle;
